module.exports = __webpack_public_path__ + "fonts/Lato-Black.1233fdf1.ttf";